import type { AgentMemoryEvidence } from '@/hooks/profile/useAgentMemory';
import {
  AccordionChevron,
  AccordionItem,
  AccordionPanel,
  AccordionTrigger,
} from '@/lib/base/accordion';

interface RuleEvidenceProps {
  evidence: AgentMemoryEvidence[];
}

const FALLBACK_EVIDENCE_LINE = 'A correction you made';

export function RuleEvidence({ evidence }: RuleEvidenceProps) {
  const count = evidence.length;
  const triggerLabel = `Learned from ${count} ${count === 1 ? 'decision' : 'decisions'}`;

  return (
    <AccordionItem className='mt-1'>
      <AccordionTrigger className='flex items-center gap-1 text-xs text-fg-tertiary hover:text-fg-secondary'>
        <span>{triggerLabel}</span>
        <AccordionChevron className='size-3.5' />
      </AccordionTrigger>
      <AccordionPanel className='pt-1.5 pb-1 pl-3'>
        <ul className='space-y-1'>
          {evidence.map((item, index) => (
            <li
              // eslint-disable-next-line react/no-array-index-key -- evidence entries have no stable id; the list is append-only and never reordered within a render
              key={index}
              className='text-xs text-fg-tertiary'
            >
              {item.summary ?? FALLBACK_EVIDENCE_LINE}
            </li>
          ))}
        </ul>
      </AccordionPanel>
    </AccordionItem>
  );
}
